import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  title: { fontSize: 24, lineHeight: 30, ...Fonts.type.bold, marginBottom: 16 },
  content: color => ({
    fontSize: 16.6,
    lineHeight: 22.9,
    marginBottom: 22.9,
    flex: 1,
    ...(color ? { color } : {}),
  }),
  noMargin: { marginTop: 0, marginBottom: 0 },
  bold: color => ({ ...Fonts.type.bold, ...(color ? { color } : {}) }),
  boldDescription: color => ({
    ...Fonts.type.bold,
    ...(color ? { color } : {}),
    marginBottom: 10,
  }),
  rowContainer: { flexDirection: 'row' },
  bullet: (theme, color) => ({
    width: 8,
    height: 8,
    borderRadius: 100,
    marginTop: 8,
    backgroundColor: color ?? theme.colors.text.primary,
    marginHorizontal: 16,
  }),
  more: (theme, isMore) => ({
    alignSelf: 'center',
    ...(isMore ? { marginTop: -12.9 } : {}),
    color: theme.colors.activeTabColorThree,
  }),
  breakdownContainer: { marginBottom: 33 },
});
